/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021-2025 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import MachinesReduces from './MachineList/MachinesReduces';
import SoftwareReducer from './SoftwareList/SoftwareReducer';
import FairsReducer from './FairList/FairsReducer';
import UsersReducer from './UserList/UsersReducer';
import ErrorsReducer from './Errors/ErrorsReducer';
import CompanyReducer from './CompanyData/CompanyReducer';
import MsgListReducer from 'MsgList/MsgListReducer';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const store = configureStore({
  reducer: {
    machines: MachinesReduces,
    errors: ErrorsReducer,
    softwares: SoftwareReducer,
    fairs: FairsReducer,
    users: UsersReducer,
    companies: CompanyReducer,
    msgList: MsgListReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type StoreType = ReturnType<typeof store.getState>;

const container = document.getElementById('root');

if (container != null) {
  const root = createRoot(container);
  if (baseUrl != null) {
    root.render(
      <BrowserRouter basename={baseUrl}>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>,
    );
  }
}

registerServiceWorker();
